import { Button, CircularProgress, Grid } from "@material-ui/core";
import { Print } from "@material-ui/icons";
import moment from "moment";
import { useContext, useState } from "react";
import { QueryParamsContext } from "../../../../../context/QueryParamsContext";
import { printREtoPDF } from "../../../../../repositories/qerpapi/erp/financeiro/ResultadoExercicioRepository";
import { notify } from "../../../../../utils/notify";
import { periods, reportTypes } from "../../../constants";
import {
  accountingSystems,
  categorizedReleases,
} from "../../ResultadoExercicioConstant";
import { useResultadoExercicioService } from "../../contexts/ResultadoExercicioContext";
import ExportButton from "../ExportButton";
import OrientationMenuButton from "../OrientationMenuButton";

export const ReportActions = () => {
  const [printLoading, setPrintLoading] = useState(false);
  const {
    cachedPeriodTotal: total,
    cachedPeriodResult: period,
    filters,
    cachedCompanies,
    cachedMovementData,
    isConsolidated,
    financeCategoriesFilter,
    isGroupedByFinanceCategory,
    orientation,
  } = useResultadoExercicioService();
  const { queryParams } = useContext(QueryParamsContext);

  return (
    <Grid item container direction="row" spacing={1}>
      <Grid item xs />
      <Grid item>
        <ExportButton
          data={cachedMovementData}
          filename={`resultado-exercicio-${Date.now()}`}
        />{" "}
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="contained"
          startIcon={printLoading ? <CircularProgress size={16} /> : <Print />}
          color="primary"
          disabled={printLoading || !cachedMovementData.length}
          onClick={async () => {
            const filtersDescriptions = {
              period: {
                label: "Período",
                formatedValue: (searchPeriod) => {
                  const objEntries = Object.entries(periods);
                  const [key] = objEntries.find(
                    ([_, value]) => value === searchPeriod
                  );
                  return key;
                },
              },
              startDate: {
                label: "Data inicial",
                formatedValue: (date) =>
                  moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
              },
              endDate: {
                label: "Data final",
                formatedValue: (date) =>
                  moment(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
              },
              multicompany: {
                label: "Empresa",
                formatedValue: (company) => {
                  const objEntries = Object.entries(cachedCompanies);
                  const companies = objEntries.find(
                    ([_, value]) => value === company
                  );
                  return companies[0] ?? queryParams?.nomeempresa;
                },
              },
              reportType: {
                label: "Tipo",
                formatedValue: (type) => {
                  const objEntries = Object.entries(reportTypes);
                  const [key] = objEntries.find(([_, value]) => value === type);
                  return key;
                },
              },
              categorizedRelease: {
                label: "Lançamentos categorizados",
                formatedValue: (type) => {
                  const objEntries = Object.entries(categorizedReleases);
                  const [key] = objEntries.find(([_, value]) => value === type);
                  return key;
                },
              },
              accountingSystem: {
                label: "Regime contábil",
                formatedValue: (type) => {
                  const objEntries = Object.entries(accountingSystems);
                  const [key] = objEntries.find(([_, value]) => value === type);
                  return key;
                },
              },
              showNotPayedAccounts: {
                label: "Exibir contas não pagas",
                formatedValue: (value) => (value ? "Sim" : "Não"),
              },
              showNotReceivedTitles: {
                label: "Exibir títulos não recebidos",
                formatedValue: (value) => (value ? "Sim" : "Não"),
              },
              groupByFinanceCategory: {
                label: "Exibir categorias do financeiro",
                formatedValue: (value) => (value ? "Sim" : "Não"),
              },
              financeCategories: {
                label: "Categorias do financeiro",
                formatedValue: (value) => {
                  const categoryIds = value.split(",");
                  const financeCategories = financeCategoriesFilter.filtered
                    .filter((category) =>
                      categoryIds.includes(`${category.id}`)
                    )
                    .map((category) => category.desc);

                  if (!financeCategories.length) {
                    return "Exibindo todas as categorias";
                  }

                  return financeCategories.join(",");
                },
              },
            };

            setPrintLoading(true);

            const pdfBody = {
              title: "Relatório de Resultado do Exercício",
              type: isConsolidated ? "CONSOLIDADO" : "DETALHADO",
              orientation: orientation,
              group: isGroupedByFinanceCategory ? "Grupo" : "Sem agrupamento",
              companyName: queryParams?.nomeempresa,
              companyFantasy: queryParams?.apelido,
              headerLogo: queryParams?.imagebase64,
              footerLogo: queryParams?.imagebase64,
              groupByFinanceCategories: isGroupedByFinanceCategory,
              login: queryParams?.usuario_nome,
              filter: Object.entries(filters).map(([key, value]) => ({
                field: filtersDescriptions[key].label,
                value: filtersDescriptions[key].formatedValue(value),
              })),
              movement: cachedMovementData,
              searchPeriod: period,
              total,
            };
            const res = await printREtoPDF(pdfBody);
            setPrintLoading(false);
            if (res?.status !== 200) {
              return notify("Falha ao imprimir relatório", true, "error");
            }

            const base64PDF = res?.data?.fileBase64;
            const binaryString = atob(base64PDF);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
            const blob = new Blob([bytes], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            window.open(url);
          }}
        >
          {printLoading ? "Gerando relatório..." : "Imprimir"}
        </Button>
      </Grid>
      <Grid item>
        <OrientationMenuButton label={"Orientação"} />
      </Grid>
    </Grid>
  );
};
